import { makeActionCreator } from '../../../utilities'
import { PNNVConstants } from './pnnv.constants'

export const setNumberPadAndCalendarPNNVIsOpen = makeActionCreator(
  PNNVConstants.SET_NUMBERPAD_CALENDAR_IS_OPEN,
  'isOpen'
)
export const setNumberPadAndCalendarCurrentPNNVValue = makeActionCreator(
  PNNVConstants.SET_NUMBERPAD_CALENDAR_CURRENT_PNNV_VALUE,
  'currentPNNVValue'
)
export const setNumberPadAndCalendarPNNVOptions = makeActionCreator(
  PNNVConstants.SET_NUMBERPAD_CALENDAR_OPTIONS,
  'options'
)
export const setNumberPadAndCalendarPNNVListHeader = makeActionCreator(
  PNNVConstants.SET_NUMBERPAD_CALENDAR_PNNV_LIST_HEADER,
  'pnnvListHeader'
)
export const setNumberPadAndCalendarPNNVLabel = makeActionCreator(
  PNNVConstants.SET_NUMBERPAD_CALENDAR_PNNV_LABEL,
  'pnnvLabel'
)
export const setNumberPadAndCalendarOnPNNVChangeHandler = makeActionCreator(
  PNNVConstants.SET_NUMBERPAD_CALENDAR_PNNV_CHANGE_HANDLER,
  'onPNNVChangeHandler'
)
export const setNumberPadAndCalendarPNNVCustomEvent = makeActionCreator(
  PNNVConstants.SET_NUMBERPAD_CALENDAR_CUSTOM_EVENT,
  'customEvent'
)
export const setNumberPadAndCalendarPNNVNemsis = makeActionCreator(
  PNNVConstants.SET_NUMBERPAD_CALENDAR_NEMSIS,
  'nemsis'
)

export const setFreeTextFieldPNNVIsOpen = makeActionCreator(PNNVConstants.SET_FREE_TEXT_IS_OPEN, 'isOpen')
export const setFreeTextFieldPNNVShowPWAPNNVBar = makeActionCreator(
  PNNVConstants.SET_FREE_TEXT_SHOW_PWA_PNNV_BAR,
  'showPWAPNNVBar'
)
export const setFreeTextFieldCurrentPNNVValue = makeActionCreator(
  PNNVConstants.SET_FREE_TEXT_CURRENT_PNNV_VALUE,
  'currentPNNVValue'
)
export const setFreeTextFieldPNNVOptions = makeActionCreator(PNNVConstants.SET_FREE_TEXT_OPTIONS, 'options')
export const setFreeTextFieldPNNVListHeader = makeActionCreator(
  PNNVConstants.SET_FREE_TEXT_PNNV_LIST_HEADER,
  'pnnvListHeader'
)
export const setFreeTextFieldPNNVLabel = makeActionCreator(PNNVConstants.SET_FREE_TEXT_PNNV_LABEL, 'pnnvLabel')
export const setFreeTextFieldOnPNNVChangeHandler = makeActionCreator(
  PNNVConstants.SET_FREE_TEXT_PNNV_CHANGE_HANDLER,
  'onPNNVChangeHandler'
)
export const setFreeTextFieldPNNVCustomEvent = makeActionCreator(
  PNNVConstants.SET_FREE_TEXT_CUSTOM_EVENT,
  'customEvent'
)
export const setFreeTextFieldPNNVShowConfirmation = makeActionCreator(
  PNNVConstants.SET_FREE_TEXT_SHOW_CONFIRMATION,
  'showConfirmation'
)
export const setFreeTextFieldNonPNNVDataReset = makeActionCreator(
  PNNVConstants.SET_FREE_TEXT_NON_PNNV_DATA_RESET,
  'nonPNNVDataResetFunction'
)
export const setFreeTextPNNVNemsis = makeActionCreator(PNNVConstants.SET_FREE_TEXT_NEMSIS, 'nemsis')
export const preventResetPNNVState = makeActionCreator(
  PNNVConstants.PREVENT_RESET_PNNV_VALUE,
  'preventResetIdentifiers'
)
export const setPNNVStateValues = makeActionCreator(PNNVConstants.SET_PNNV_STATE_VALUES, 'freeTextField')
export const resetPNNVState = makeActionCreator(PNNVConstants.RESET_STATE)
